module.exports = __webpack_public_path__ + "img/交易鉴证.532b184b.png";